import { CodingExamQuestion } from '../../../../../store/exam/types';
import { useProctoring } from '../../../../../hooks/useProctoring';
import QuestionPanel from '../../components/QuestionPanel';
import { RefObject, useEffect, useState } from 'react';
import ExamStream from '../../components/ExamStream';
import CodeEditor from '../../components/CodeEditor';
import { PROCTORING_TYPE } from '../../constants';
import styles from './style.module.scss';
import Webcam from 'react-webcam';

interface Props {
    counter: number;
    isPaused: boolean;
    examId?: string;
    userId: string | null;
    questionNumber: number;
    question: CodingExamQuestion;
    webcamRef: RefObject<Webcam>;
    onStartCapture: () => void;
    onAnswerChange: (answer: string) => void;
};

/** The exam itself: the question, the proctoring corner and the editor below them. */
function Exam(props: Props) {
    const {
        userId,
        examId,
        counter,
        isPaused,
        question,
        webcamRef,
        questionNumber,
        onStartCapture,
        onAnswerChange,
    } = props;

    // Collapsing the question hands the space it took over to the editor.
    const [showMore, setShowMore] = useState(true);

    useProctoring(userId, examId, questionNumber, PROCTORING_TYPE, isPaused);

    useEffect(() => {
        // The camera moved here from the header, so its recording starts over.
        onStartCapture();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.content} data-show-more={showMore}>
                <div className={styles.top_section}>
                    <QuestionPanel
                        showMore={showMore}
                        number={questionNumber}
                        examples={question.examples}
                        description={question.description}
                        onToggleShowMore={() => setShowMore(prev => !prev)}
                    />
                    <ExamStream
                        counter={counter}
                        showMore={showMore}
                        webcamRef={webcamRef}
                    />
                </div>
                <CodeEditor
                    question={question}
                    showMore={showMore}
                    onChange={onAnswerChange}
                />
            </div>
        </div>
    )
};

export default Exam;
